import { render } from "./thematic-page.vue?vue&type=template&id=794aa678"
import script from "./thematic-page.vue?vue&type=script&lang=js"
export * from "./thematic-page.vue?vue&type=script&lang=js"

import "./thematic-page.vue?vue&type=style&index=0&id=794aa678&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__